import { Injectable } from '@angular/core';
import { StorageMap } from '@ngx-pwa/local-storage';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class StorageService {

  constructor(public storage: StorageMap) { }

  setValue(key: string, value: any) {
    const res = this.storage.set(key, value);
    return firstValueFrom(res);
  }

  getValue(key: string) {
    const res = this.storage.get(key);
    return firstValueFrom(res);
  }

  removeKey(key: string) {
    const res = this.storage.delete(key);
    return firstValueFrom(res);
  }
}
